<template>
  <v-dialog
    v-if="isDataLoadedFromServer"
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="850"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Edit Record</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div
        class="modal-body d-flex flex-column h-550px scroll-y mx-5 mx-xl-15 py-7"
      >
        <div class="h-75px">
          <v-text-field
            v-model="formData.system"
            dense
            label="System"
            clearable
            outlined
          ></v-text-field>
        </div>

        <div class="h-75px">
          <v-text-field
            v-model="formData.url"
            dense
            label="Url"
            clearable
            outlined
          ></v-text-field>
        </div>

        <v-textarea
          v-model="formData.headers"
          class="mb-8"
          label="Headers"
          clearable
          auto-grow
          outlined
          rows="1"
          hide-details
          dense
        ></v-textarea>

        <v-textarea
          v-model="formData.parameters"
          class="mb-8"
          auto-grow
          label="Parameters"
          clearable
          outlined
          rows="1"
          hide-details
          dense
        ></v-textarea>

        <v-textarea
          v-model="formData.body"
          class="mb-8"
          auto-grow
          label="Body"
          clearable
          outlined
          rows="1"
          hide-details
          dense
        ></v-textarea>

        <v-textarea
          v-model="formData.others"
          class="mb-8"
          auto-grow
          label="Others"
          clearable
          outlined
          rows="1"
          hide-details
          dense
        ></v-textarea>

        <!--begin::Actions-->
        <div class="mb-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetEditForm"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitEditForm"
          >
            Update
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import swalEdited from "@/core/services/AlertServices/SwalEdited";

export default {
  name: "EditItem",
  props: ["refresher", "pageLoader"],
  data: () => ({
    dialog: false,
    serverData: null,
    formData: {
      system: null,
      url: null,
      headers: null,
      parameters: null,
      body: null,
      others: null,
    },
  }),
  methods: {
    loadDataFromServer() {
      this.pageLoader(true);
      let data = { id: this.$store.getters.getItemForAction.id };
      ApiService.post("/organization/systemCredentials/edit", data)
        .then((response) => {
          this.serverData = response.data.system_credential;
          this.formData.system = this.serverData.system;
          this.formData.url = this.serverData.url;

          this.formData.headers = JSON.stringify(
            JSON.parse(this.serverData.headers),
            undefined,
            4
          );
          // ["app_key", "app_secret"],
          this.formData.parameters = JSON.stringify(
            JSON.parse(this.serverData.parameters),
            null,
            4
          );
          this.formData.body = JSON.stringify(
            JSON.parse(this.serverData.body),
            undefined,
            4
          );
          this.formData.others = JSON.stringify(
            JSON.parse(this.serverData.others),
            undefined,
            4
          );

          // this.resetEditForm();
          this.pageLoader(false);
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },
    submitEditForm() {
      this.pageLoader(true);
      let sendData = {
        id: this.$store.getters.getItemForAction.id,
        ...this.formData,
      };
      ApiService.post("/organization/systemCredentials/update", sendData)
        .then(() => {
          swalEdited();
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    resetEditForm() {
      // if (this.serverData) {
      //   let copy = { ...this.serverData.system_credential };
      //   Object.entries(this.formData).forEach((localD) => {
      //     Object.entries(this.serverData.system_credential).forEach(
      //       (serverD) => {
      //         if (localD[0] === serverD[0]) {
      //           this.formData[localD[0]] = copy[serverD[0]];
      //         }
      //       }
      //     );
      //   });
      //   // var obj = JSON.parse(ugly);
      //   // var pretty = JSON.stringify(obj, undefined, 4);
      //
      //   this.formData.headers = JSON.stringify(
      //     JSON.parse(this.formData.headers),
      //     undefined,
      //     4
      //   );
      //   this.formData.parameters = JSON.stringify(
      //     JSON.parse(this.formData.parameters),
      //     undefined,
      //     4
      //   );
      //   this.formData.body = JSON.stringify(
      //     JSON.parse(this.formData.body),
      //     undefined,
      //     4
      //   );
      //   this.formData.others = JSON.stringify(
      //     JSON.parse(this.formData.others),
      //     undefined,
      //     4
      //   );
      // } else {
      this.formData = {
        system: null,
        url: null,
        headers: null,
        parameters: null,
        body: null,
        others: null,
      };
      // }
    },
    toggleModal() {
      if (this.dialog) {
        this.resetEditForm();
      } else {
        this.loadDataFromServer();
      }
      this.dialog = !this.dialog;
    },
  },
  computed: {
    isDataLoadedFromServer: function () {
      return !!this.serverData;
    },
  },
};
</script>
